import { useAuthContext } from "authentication";
import { observer } from "mobx-react";
import React, { ReactNode } from "react";
import { Permission } from "./constants";
import { checkPermissions } from "./utils";

interface Props {
  requiredPermission?: Permission;
  renderNoAccessComponent?: () => ReactNode;
  children: ReactNode;
}

export const AccessControlBase: React.FC<Props> = ({
  requiredPermission,
  children,
  renderNoAccessComponent,
}) => {
  const { authStore } = useAuthContext();

  const hasAccess = requiredPermission
    ? checkPermissions(authStore.permissions ?? [], requiredPermission)
    : true;

  if (hasAccess) {
    return <>{children}</>;
  }
  return renderNoAccessComponent ? <>{renderNoAccessComponent()}</> : <></>;
};

export const AccessControl = observer(AccessControlBase);
